import ReactPlayer from 'react-player'

import type { ReactElement } from 'react'

import Modal from '~/components/Modal'

import './styles.scss'

interface Props {
  downloadUrl: string
  fileType: string
  isOpen: boolean
  onClose: () => void
}

const FilePreviewModal = ({ downloadUrl, fileType, isOpen, onClose }: Props): ReactElement => {
  const getPreview = (fileType: string) => {
    const prefix = fileType?.split('/')[0]

    switch (prefix) {
      case 'image':
        return <img alt="" src={downloadUrl} />
      case 'video':
        return <ReactPlayer controls height="100%" playing url={downloadUrl} width="100%" />
      case 'audio':
        return <audio controls src={downloadUrl} />
      default:
        return <span>This file has no preview available.</span>
    }
  }

  return (
    <Modal className="file-preview-modal" isOpen={isOpen} onCloseModal={onClose}>
      <div className="media-container">{getPreview(fileType)}</div>
    </Modal>
  )
}

export default FilePreviewModal
